import { Divider, Label, pxToRem, useStyles } from '@archipro-design/aria';

import * as S from './Testimonials.style';

import SwiperCore from 'swiper';
import { Pagination } from 'swiper/modules';

import { TestimonialSlideMobile } from './TestimonialSlide.mobile';
import { Swiper, SwiperSlide } from 'swiper/react';

// oxlint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Pagination]);

export interface ProfessionalDetailsTestimonial {
    Content: string;
    Source?: string | null;
}
export const TestimonialsMobile: React.FC<{
    professionalTestimonials: ProfessionalDetailsTestimonial[];
}> = ({ professionalTestimonials }) => {
    const multipleTestimonials = professionalTestimonials.length > 1;

    const { css } = useStyles({
        index: 0,
        inUpperBound: false,
        inLowerBound: true,
        multipleTestimonials,
    });

    if (!professionalTestimonials.length) {
        return null;
    }

    return (
        <div className={css(S.TestimonialsWrapperMobile)}>
            <Label className={css(S.TestimonialHeaderMobile)} variant="01">
                Testimonials
            </Label>
            <div className={css(S.TestimonialsSwiperWrapper)}>
                <Swiper
                    spaceBetween={6}
                    loop={false}
                    pagination={{
                        type: 'fraction',
                        el: '.swiper-testimonial-pagination',
                    }}
                >
                    {professionalTestimonials.map((t, i) => (
                        <SwiperSlide key={i}>
                            <div className={css(S.TestiomnialSlideWrapper)}>
                                <TestimonialSlideMobile
                                    content={t.Content}
                                    source={t.Source}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {professionalTestimonials?.length > 1 && (
                    <div className="swiper-testimonial-pagination" />
                )}
            </div>
            <Divider
                size={1}
                className={css({
                    marginTop: pxToRem(48),
                    opacity: 0.21,
                })}
            />
        </div>
    );
};
